<template>
  <div>


    <div class="row">
      <div class="col-12 col-xl-10 m-auto">
        <div class="card">
          <div class="card-header">
            <h4 class="title">My Analyses</h4>
          </div>
          <div class="card-body">

            <div class="row" v-if="loading">
              <div class="col-12 text-center font-weight-bold">
                <span class="text-danger d-block"><i class="fa fa-spinner fa-spin"></i> {{ $t('common.loading') }}...</span>
              </div>
            </div>

            <div class="row mt-5">
              <div class="col-12 text-center">

                <el-table class="table-striped" :data="tasks" border style="width: 100%">

                  <el-table-column key="request_date" :min-width="110" prop="request_date" :label="$t('common.date')">
                    <template #default="scope">
                      {{ formatDate(scope.row.request_date, true) }}
                    </template>
                  </el-table-column>
                  <el-table-column key="search_company" :min-width="180" prop="search_company" label="Company"></el-table-column>
                  <el-table-column key="analysis_start_date" :min-width="110" prop="analysis_start_date" label="Analysis From" label-class-name="text-break">
                    <template #default="scope">
                      {{ formatDate(scope.row.analysis_start_date.date, false) }}
                    </template>
                  </el-table-column>
                  <el-table-column key="analysis_end_date" :min-width="110" prop="analysis_end_date" label="Analysis To" label-class-name="text-break">
                    <template #default="scope">
                      {{ formatDate(scope.row.analysis_end_date.date, false) }}
                    </template>
                  </el-table-column>
                  <el-table-column key="status" :min-width="160" prop="status" label="Status">
                    <template #default="scope">
                      <span v-if="scope.row.status" class="text-break">
                        {{ $t('task_status.' + scope.row.status) }}
                        <span v-if="scope.row.status === 'generate_sentiment' && scope.row.sentiment_offset !== null" class="text-break">
                          {{ parseInt(scope.row.sentiment_offset / scope.row.tot_insights * 100) }}%
                        </span>
                      </span>
                    </template>
                  </el-table-column>

                  <el-table-column key="irg_score" :min-width="100" prop="irg_score" label="IRG Score" label-class-name="text-break">
                  </el-table-column>

                  <el-table-column key="tot_insights" :min-width="100" prop="tot_insights" label="Total news" label-class-name="text-break">
                    <template #default="scope">
                      <span v-if="scope.row.tot_insights !== null" >
                        {{ scope.row.tot_insights }}
                      </span>
                      <span v-else-if="scope.row.status !== 'stopped'">
                        Pending..
                      </span>
                    </template>
                  </el-table-column>

                  <el-table-column key="actions" :min-width="100" prop="id" :label="$t('common.actions')">
                    <template #default="scope">
                      <span class="d-none">{{scope.row.id}}</span>
                      <router-link :to="'/task/show/' + scope.row.id"
                                   v-if="!loading && !saving && (scope.row.status === 'completed' || scope.row.status === 'no_news')">
                        <n-button native-type="button" type="primary" class="btn btn-sm btn-icon">
                          <font-awesome-icon icon="eye"></font-awesome-icon>
                        </n-button>
                      </router-link>
                      <n-button v-else-if="!loading && !saving && scope.row.status !== 'stopped'"
                                native-type="button" type="warning" class="btn btn-sm btn-icon"
                                v-on:click="confirmCancel(scope.$index, scope.row.id, scope.row.search_company)">
                        <i class="fa fa-stop"></i>
                      </n-button>

                    </template>
                  </el-table-column>
                </el-table>

              </div>
            </div>


          </div>
        </div>
      </div>
    </div>





  </div>
</template>

<script>
  import axios from 'axios';
  import { ElMessage, ElDatePicker, ElInput, ElSelect, ElOption, ElTable, ElTableColumn } from "element-plus";
  import Swal from "sweetalert2";


  export default {
    name: "ListTasks",
    components: {
        [ElDatePicker.name]: ElDatePicker,
        [ElInput.name]: ElInput,
        [ElSelect.name]: ElSelect,
        [ElOption.name]: ElOption,
        [ElTable.name]: ElTable,
        [ElTableColumn.name]: ElTableColumn
    },
    data () {
      return {
        loading: true,
        saving: false,
        error: null,
        tasks: [],
      }
    },
    methods: {
      showError(error) {
          this.error = "";
          if (error.response && error.response.status === 401 && error.config && !error.config.__isRetryRequest) {
              this.error = this.$i18n.t("error.login_expired");
              this.$store.commit('logout');
              this.$router.push('/login');
          }
          else if (error.response && error.response.data && error.response.data.violations &&
              error.response.data.violations.length > 0) {
              for (let i = 0; i < error.response.data.violations.length; i++)
              {
                  let stringErr = error.response.data.violations[i].message;
                  if(stringErr.endsWith("."))
                      stringErr = stringErr.slice(0, -1);
                  this.error += this.$i18n.t(stringErr) + ". ";
              }
          } else if(error.response && error.response.data && error.response.data.message)
          {
              let stringErr = error.response.data.message;
              if(stringErr.endsWith("."))
                  stringErr = stringErr.slice(0, -1);
              this.error = this.$i18n.t("error." + stringErr);
          }
          else if (error.response && error.response.data && error.response.data['hydra:description'])
              this.error = this.$i18n.t("error." + error.response.data['hydra:description']);
          else this.error = this.$i18n.t("error.try_again");
          ElMessage.error(this.error);
          console.log(error);
      },
      formatDate(date, time = true) {
          var dateObj = new Date(date);
          if(time)
              return dateObj.toLocaleString();
          else
              return dateObj.toLocaleDateString();
      },
      disabledDate(time) {
          return time.getTime() > (new Date());
      },
      confirmCancel(rowIndex, task_id, company_name) {
        Swal.fire({
          title: this.$i18n.t('are_you_sure'),
          text: "You are going to cancel the analysis on " + company_name + ". Would you like to proceed?",
          showCancelButton: true,
          confirmButtonText: this.$i18n.t('common.yes'),
          confirmButtonColor: '#FFB236',
          cancelButtonText: this.$i18n.t('common.no'),
          allowOutsideClick: () => !Swal.isLoading(),
          backdrop: true
        }).then((result) => {
          if (result.isConfirmed) {
            Swal.showLoading();
            axios.post(process.env.VUE_APP_SERVER_BASE_URL + 'stop_task/', {task_id: task_id})
            .then(response => {
              if (response.data.status !== 1)
                this.showError(response);
              else {

                Swal.fire({
                  icon: 'success',
                  title: 'Analysis canceled',
                  text: "The analysis of " + company_name + " has been successfully canceled."
                });
                this.tasks[rowIndex].status = "stopped";
              }
            }).catch(error => {
              this.showError(error);
            }).finally(() => {Swal.hideLoading();});
          }
        });
      }
    },
    computed: {
    },
    beforeMount() {
        //TODO: pagination?
        axios.get(process.env.VUE_APP_SERVER_BASE_URL + "list_tasks/")
        .then(response => {
            this.tasks = response.data["tasks"];
        }).catch(error => {this.showError(error);}).finally(() => {this.loading = false;});
    },
  }
</script>

<style scoped>

</style>
